/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EDriverStatusSortType {
  DriverName = 0,
  StartTime = 1
}
